














import CategoryCard from "@/components/CategoryCard.vue";
import { tmCategories } from "@/models/category";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    CategoryCard
  }
})
export default class CategoryList extends Vue {
  public readonly categories = tmCategories;
}
